export function getCurrencyProps() {
  return {
    currency: process.env.NEXT_PUBLIC_CURRENCY || 'EUR',
    checkoutCurrency:
      process.env.NEXT_PUBLIC_CHECKOUT_CURRENCY || process.env.NEXT_PUBLIC_CURRENCY || 'EUR',
    multiplicator: parseFloat(process.env.NEXT_PUBLIC_CURRENCY_MULTIPLICATOR || '1'),
  };
}
